/** @jsxImportSource @emotion/react */
import { TableBody } from "../../components/table-components/TableBody";
import { Table } from "../../components/table-components/Table";
import { TableRowHeader } from "../../components/table-components/TableRowHeader";
import { TableCellHeaderText } from "../../components/table-components/TableCellHeaderText";
import { ProductsTableRow } from "./ProductsTableRow";
import { firstTableCellStyle } from "../../style-util";
import { CardTableEmptyPlaceholder } from "../../components/table-components/CardTableEmptyPlaceholder";
import { ProductListItem } from "./models/product";

interface Props {
  products: ProductListItem[];
}

export const ProductsTable = ({ products }: Props) => {
  if (products.length === 0) {
    return (
      <CardTableEmptyPlaceholder>
        No products match your filters
      </CardTableEmptyPlaceholder>
    );
  }

  return (
    <Table>
      <thead>
        <TableRowHeader>
          <TableCellHeaderText css={firstTableCellStyle}>
            Img
          </TableCellHeaderText>
          <TableCellHeaderText>Admin name</TableCellHeaderText>
          <TableCellHeaderText>Display name</TableCellHeaderText>
          <TableCellHeaderText>Category</TableCellHeaderText>
          <TableCellHeaderText>Price</TableCellHeaderText>
          <th />
        </TableRowHeader>
      </thead>
      <TableBody>
        {products.map((product, i) => (
          <ProductsTableRow key={i} product={product} />
        ))}
      </TableBody>
    </Table>
  );
};
